import type { ReactNode } from "react";

import * as React from "react";

import { FeatureFlagsTab } from "@v2/features/admin/tabs/FeatureFlags";
import { MiscellaneousTab } from "@v2/features/admin/tabs/Miscellaneous";
import { OptionsTab } from "@v2/features/admin/tabs/Options";

type AdminSection = {
  component: ReactNode;
  title: string;
};

/**
 * Sections shared between the V2 admin panel and V1 debug left panel.
 * To add a new section to both panels, add it here.
 */
export function getAdminSections(): AdminSection[] {
  return [
    {
      component: <FeatureFlagsTab />,
      title: "Feature Flags",
    },
    {
      component: <OptionsTab />,
      title: "Options",
    },
    {
      component: <MiscellaneousTab />,
      title: "Miscellaneous",
    },
  ];
}
